/**
 * Who the bout's shove leaves alone (systems/duelMatch.ts `shove`): a fighter in armour (systems/duelArmor.ts) or being
 * thrown / down (systems/duelKnock.ts). A tiny registry so duelMatch needs one line and no import of those systems.
 */
const HOLDS = new WeakMap<object, ((id: number) => boolean)[]>();

export function addShoveHold(w: object, f: (id: number) => boolean): void {
  const l = HOLDS.get(w) ?? [];
  l.push(f);
  HOLDS.set(w, l);
}

/** True when a shove on this fighter is to be dropped. */
export function shoveHeld(w: object, id: number): boolean {
  return (HOLDS.get(w) ?? []).some((f) => f(id));
}
